import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Routesmap } from "./Routesmap";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useAppMessage } from "./hooks/useAppMessage";
import { FlightModalAPI } from "./API/FlightModalAPI";
import { FlightModelProvider } from "./contexts/FlightModelContext";
import { NotificationProvider } from "./contexts/NotificationContext";

function App() {
  const isLoggedIn = !!localStorage.getItem("SWAAccessToken");
  const [isLoading, setIsLoading] = useState(
    isLoggedIn && !localStorage.getItem("flight_model"),
  );
  const [messageApi, contextHolder] = useAppMessage();

  useEffect(() => {
    if (!isLoggedIn || localStorage.getItem("flight_model")) {
      setIsLoading(false);
      return;
    }

    const fetchFlightData = async () => {
      await FlightModalAPI.getFlightModals()
        .then((res) => {
          if (res?.data?.status === true) {
            // localStorage.setItem(
            //   "flight_model",
            //   res?.data?.selected_flight_model,
            // );
            
            setIsLoading(false);
          } else {
            messageApi.open({
              type: "error",
              content: res?.data?.message,
              duration: 6,
            });
          }
        })
        .catch(() =>
          messageApi.open({
            type: "error",
            content: "Internal Server Error",
            duration: 6,
          }),
        );
    };

    fetchFlightData();
  }, [isLoggedIn, messageApi]);

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        {contextHolder}
        <Spin size="large" />
      </div>
    );
  }

  return (
    <FlightModelProvider>
      <NotificationProvider>
        <Router>
          {contextHolder}
          <Routesmap />
        </Router>
      </NotificationProvider>
    </FlightModelProvider>
  );
}

export default App;
